module.exports = __webpack_public_path__ + "5153ff9ec58749d12102f00b3024958f.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/step4.png
// module id = 678
// module chunks = 0